import { GenericObject } from "custom-types/generic-object";

export function removeEmptyOrNullObjectValue(obj: GenericObject) {
    Object.keys(obj).forEach(
        (k) =>
            (obj[k] && typeof obj[k] === "object" && removeEmptyOrNullObjectValue(obj[k])) ||
            (!obj[k] && obj[k] !== undefined && delete obj[k])
    );
    return obj;
}
